module.exports = __webpack_public_path__ + "b26f19c43529751b6c8db819ee3911b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-class.png
// module id = 607
// module chunks = 0